import { gql } from 'apollo-boost'

const login = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      me {
        nome
        ruolo
        email
      }
    }
  }
`

export default login


// WEBPACK FOOTER //
// ./src/graphql/mutations/login.js